import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Collapse,
  Typography
} from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import UserDashboard from './userDashBoard';
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    margin: 'auto',
    marginTop: theme.spacing(5),
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  chartContainer: {
    width: '100%', // Ensure the container occupies full width
  },
}));

const MenuCard = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        action={
          <IconButton
            className={`${classes.expand} ${expanded ? classes.expandOpen : ''}`}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
        title="Yearly Data"
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Yearly User Count and Growth Rate</Typography>
          <div className={classes.chartContainer}>
            <UserDashboard />
          </div>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default MenuCard;